import { RANKS } from "../points/ranks";

/**
 * Ermittelt den Rank-Namen anhand der Punkte.
 * Nimmt den höchsten Rank, dessen threshold <= points ist.
 */
export function getRankNameFromPoints(points?: number | null): string {
  const p = Math.max(0, Math.floor(points ?? 0));

  if (!Array.isArray(RANKS) || RANKS.length === 0) return "Rookie";

  // robust, falls RANKS nicht sortiert ist
  const sorted = [...RANKS].sort((a, b) => (a.threshold ?? 0) - (b.threshold ?? 0));

  let current = sorted[0];
  for (const r of sorted) {
    if ((r.threshold ?? 0) <= p) current = r;
    else break;
  }
  return current?.name ?? "Rookie";
}
